// Canonical roster of internal Showman team Firebase UIDs.
// Every hardcoded user check in the app should reference these — never inline a raw UID string.
export const USER_IDS = Object.freeze({
  JOSH: 'Clo1Va5v4pNuvE1TqHPNeKWFGay2',
  JASON: 'yJcDi4z2bffFtKq1jXI3deN8M9r1',
  LAYNE: '2S1n15f3I0OJjgpLx5pMlHdAfT13',
  CASEY: '5kpEsEowxGNSsdpPjQpS3PoL2g02',
  RACHEL: 'r1noJUdvSoZX6LIesj9eBNA5yEx1',
  OLIVIA: 'AmtbH8WVMsOneNemxsGcShyc9IE2',
  BRANDY: '9tWzGNjoUZWFjonz2PJJpAnkGxg1',
  SUSAN: 'WK7NrDb812UPUK2x7VZynNArOIo2',
  RUTH: 'RMv8Utnqrfg3UiVwSazoLs8lFE43',
  PEYTON: 'U96Q80FXz9dfgyd5NeEXLeR3Rmt1',
  KELSEY: 'o4gTo1AHudUbnKW91qVHOnmJivt2',
  // TODO: identify and rename these — they appear in access checks but are not named anywhere
  UNKNOWN_SHOW_SERIES: 'vYWkmEn4YhNfC2IRUFw4mqm6uc73', // ShowSeriesAdmin, FormSubmission
  UNKNOWN_INTERNAL_1: 'D6gMQyk65oZqA7ElVPaLXvhvYku1', // InternalDashboard
  UNKNOWN_INTERNAL_2: 'aCtWkMYHMEhP47mqVjopfEOnaY32' // InternalDashboard
})

const {JOSH, JASON, LAYNE, CASEY, RACHEL, OLIVIA, BRANDY, SUSAN, RUTH, PEYTON, KELSEY} = USER_IDS

const checkUserAccess = function (userID, accessLevel) {
  if (userID === JOSH || userID === JASON) {
    return true
  }

  if (userID === LAYNE && (accessLevel === 'SUPPORT' || accessLevel === 'FULL_TIME' || accessLevel === 'LAYNE')) {
    return true
  } else if (userID === CASEY && (accessLevel === 'SUPPORT' || accessLevel === 'FULL_TIME' || accessLevel === 'CASEY')) {
    return true
  } else if (userID === RACHEL && (accessLevel === 'SUPPORT' || accessLevel === 'RACHEL')) {
    return true
  } else if (userID === BRANDY && (accessLevel === 'SUPPORT' || accessLevel === 'BRANDY')) {
    return true
  } else if (userID === OLIVIA && (accessLevel === 'SUPPORT' || accessLevel === 'OLIVIA')) {
    return true
  } else if (userID === SUSAN && (accessLevel === 'SUPPORT' || accessLevel === 'SUSAN')) {
    return true
  } else if (userID === PEYTON && (accessLevel === 'SUPPORT' || accessLevel === 'PEYTON')) {
    return true
  } else if (userID === RUTH && (accessLevel === 'SUPPORT' || accessLevel === 'RUTH' || accessLevel === 'FULL_TIME')) {
    return true
  } else if (userID === KELSEY && (accessLevel === 'SUPPORT' || accessLevel === 'KELSEY')) {
    return true
  }

  return false
}

// Named exports so the capability layer (src/access/accessControl.js) can reuse
// the SAME uid constants instead of re-declaring them — one list of who's who.
export {
  JOSH,
  JASON,
  LAYNE,
  CASEY,
  RACHEL,
  OLIVIA,
  BRANDY,
  SUSAN,
  RUTH,
  PEYTON,
  KELSEY
}

export default {
  checkUserAccess,
  USER_IDS
}
